module.exports = __webpack_public_path__ + "img/brown.7b08f5aa.svg";